import { fetchOrThrow } from '@upright/ui/api/common/fetchers/fetch-or-throw';
import {
  MatchProductToUpgPayload,
  MatchProductToUpgResponse,
} from '@upright/common/model/input/companies/products/product-input-ui/types';

export async function fetchProductMatch(payload: MatchProductToUpgPayload): Promise<MatchProductToUpgResponse> {
  return await fetchOrThrow<MatchProductToUpgResponse>('/search/match-product-to-upg', 'POST', payload);
}
